export const getPartCountMultiplierDialogOpen = (state) => {
  return state?.partCountMultiplierDialog?.open || false;
};

export const getPartCountMultiplierDialogDefaultValue = (state) => {
  return state?.partCountMultiplierDialog?.defaultValue ?? 1;
};
